import styled from 'styled-components'
import Image from 'common/image'
import TopArrow from 'assets/top-arrow.svg'
import { useTranslation } from 'react-i18next'

const FooterContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    background-color: white;
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 100px;
    padding-right: 42px;
`

const LeftSection = styled.div`
    height: 100%;
    width: 100%;
`

const FirstLineText = styled.div`
    color: #003c84;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
    margin-bottom: 16px;
`

const SecondLineText = styled.div`
    width: 650px;
    color: #121b21;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
`

const LinkItemBar = styled.div`
    padding-top: 16px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
`

const LinkItem = styled.div`
    color: #003c84;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 142.857% */
    padding-right: 16px;
    cursor: pointer;
`

const Separator = styled.div`
    width: 1px;
    height: 12px;
    background-color: #000;
    margin-right: 16px;
`

const RightSection = styled.div`
    height: 100%;
    display: flex;
    align-items: flex-end;
`

const CopyRightText = styled.div`
    color: #003c84;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 142.857% */
    padding-right: 40px;
`

// const TopArrowContainer = styled.div`
//     cursor: pointer;
//     display: flex;
//     width: 45px;
//     height: 45px;
//     padding: 14px 12px;
//     flex-direction: column;
//     align-items: flex-start;
//     gap: 10px;
//     border-radius: 22.5px;
//     background: #043570;
// `

const FloatButtonContainer = styled.div`
    position: fixed; /* or absolute, depending on desired behavior */
    bottom: 48px;
    right: 20px;
    z-index: 1000; /* Ensure it stays on top */
`

const FabButton = styled.div`
    cursor: pointer;
    background-color: #043570;
    color: white;
    border-radius: 50%;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    /* Add hover effects, etc. */
`

export default function Footer() {
    const scrollToTop = () => {
        window.scrollTo(0, 0)
    }
    const { t } = useTranslation('', { keyPrefix: 'footer' })

    const openLinkInNewTab = (url: string) => {
        window.open(url, '_blank')?.focus()
    }

    const currentYear = new Date().getFullYear()

    return (
        <FooterContainer>
            <LeftSection>
                <FirstLineText>{t('PlayResponsibly')}</FirstLineText>
                <SecondLineText>{t('FootTextLine1')}</SecondLineText>
                <SecondLineText>{t('FootTextLine2')}</SecondLineText>
                <SecondLineText>{t('FootTextLine3')}</SecondLineText>
                <LinkItemBar>
                    <LinkItem
                        onClick={() => {
                            openLinkInNewTab(t('ContactUsUrl'))
                        }}
                    >
                        {t('ContactUs')}
                    </LinkItem>
                    <Separator />
                    <LinkItem
                        onClick={() => {
                            openLinkInNewTab(t('RulesUrl'))
                        }}
                    >
                        {t('Rules')}
                    </LinkItem>
                    <Separator />
                    <LinkItem
                        onClick={() => {
                            openLinkInNewTab(t('ResponsibleGamblingUrl'))
                        }}
                    >
                        {t('ResponsibleGambling')}
                    </LinkItem>
                    <Separator />
                    <LinkItem
                        onClick={() => {
                            openLinkInNewTab(t('PrivacyUrl'))
                        }}
                    >
                        {t('Privacy')}
                    </LinkItem>
                    <Separator />
                    <LinkItem
                        onClick={() => {
                            openLinkInNewTab(t('DisclaimerUrl'))
                        }}
                    >
                        {t('Disclaimer')}
                    </LinkItem>
                    <Separator />
                    <LinkItem
                        onClick={() => {
                            openLinkInNewTab(t('SecurityTipsUrl'))
                        }}
                    >
                        {t('SecurityTips')}
                    </LinkItem>
                </LinkItemBar>
            </LeftSection>
            <RightSection>
                <CopyRightText>
                    {t('Copyright').replace(
                        '{currentyear}',
                        currentYear.toString()
                    )}
                </CopyRightText>
                <FloatButtonContainer onClick={scrollToTop}>
                    <FabButton>
                        <Image
                            src={TopArrow}
                            width={20.5}
                            height={17}
                            alt="top arrow logo"
                        />
                    </FabButton>
                </FloatButtonContainer>
            </RightSection>
        </FooterContainer>
    )
}
